// add in the flag name of flags as strings.
// REQUIRED for any flags to work. Subscribe here for the app to listen to any of these flags and get values
// For example:
// ['feature_learn-2790_react-poc_01-2020']
export default [
  'feature_LEARN-27700_specialized-lesson-completion-updates',
  'feature_LEARN-27700_core-lesson-completion-updates',
]
